/*
 * Copyright (c) 2019. AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as React from "react";
import { Route, RouteComponentProps } from "react-router-dom";
import DocumentPage from "components/base/DocumentPage/DocumentPage";
import LegalDocumentGetter from "components/base/starbreeze/LegalDocumentGetter/LegalDocumentGetter";

export default function() {
  return [
    <Route key="HomePage" path="/" component={DocumentPage} exact />,
    // SB-260 add links to EULA, ToS, and Privacy Policy: START
    <Route
      key="terms"
      path="/terms"
      exact
      render={() => <LegalDocumentGetter tagQuery="terms" />}
    />,
    <Route
      key="privacy"
      path="/privacy"
      exact
      render={() => <LegalDocumentGetter tagQuery="privacy" />}
    />,
    // SB-260 add links to EULA, ToS, and Privacy Policy: END
    <Route
      key="DocumentPage"
      path="/:localizedPolicyId"
      component={(props: RouteComponentProps<{ localizedPolicyId: string }>) => (
        <DocumentPage localizedPolicyId={props.match.params.localizedPolicyId} />
      )}
      exact
    />,
  ];
}
